<template>
  <div style="height:100%">
    <portal to="app-header">
      <span>{{ $t('sales') }}</span>
    </portal>
    <portal to="app-extension">
      <v-toolbar
        flat
        dense
        :color="$vuetify.theme.dark ? '#121212': ''"
      >
      <span class="title">Production Orders</span>
      <v-spacer></v-spacer>
      <v-btn
        small
        color="primary"
        class="text-none"
        :to="{ name: 'create-new' }"
      >
        Create New
      </v-btn>
      </v-toolbar>
    </portal>
    <v-row class="pt-4 px-4">
      <v-col cols="12" xl="9" class="text-justify">
        <base-loading v-if="loading"></base-loading>
        <no-result v-if="!salesData"></no-result>
        <v-data-table
          :headers="headers"
          :items="salesData"
          hide-default-footer
          disable-pagination
          v-if="!loading"
        ></v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import BaseLoading from '../components/base/loading.vue';
import NoResult from '../components/base/NoResult.vue';
import { sales } from '../components/salesform.json';

export default {
  name: 'Home',
  components: {
    BaseLoading,
    NoResult,
  },
  data() {
    return {
      headers: [],
      salesData: [],
      loading: false,
    };
  },
  computed: {
  },
  mounted() {
    this.setHeader();
    this.fetchData();
    this.setExtendedHeader(true);
  },
  methods: {
    ...mapActions('sales', ['getRecords']),
    ...mapMutations('helper', ['setExtendedHeader']),
    async fetchData() {
      this.loading = true;
      this.salesData = await this.getRecords('sales');
      this.loading = false;
    },
    setHeader() {
      const filteredData = sales.fields.filter((v) => !v.hidefromtable);
      this.headers = filteredData.map((v) => ({
        text: v.lable,
        value: v.key,
        sortable: false,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.border-round {
  border-radius: 10px;
}
#home-container {
  height: calc(100vh - 220px);
  overflow: auto;
}
</style>
